export class PollerConstant {
    static readonly POLLER_START_WARN: string = "Tried to start a poller that was already polling";
    static readonly POLLER_STOP_WARN: string = "Tried to stop a poller that was already stopped";
    static readonly POLLER_SUBSCRIBE: string = "poller subscription";
    static readonly POLLER_ONREJECT_REJECT_MSG: string = "unexpected promise rejection";
    static readonly POLLER_SETTIMEOUT_REJECT_MSG: string = "timeout";

}